<p-fluid>
  <p-multiSelect #purchaseOrderStatusSelection="ngModel" name="purchaseOrderStatusSelection" [(ngModel)]="selectedPurchaseOrderStatuses"
    [options]="purchaseOrderOptions" class="multi-select" [placeholder]="placeholder()" (onChange)="onChange()"
    resetFilterOnHide="true" [appendTo]="appendTo()"  />
  <error-message [errorControl]="purchaseOrderStatusSelection">
    @if (purchaseOrderStatusSelection?.errors?.required) {
      <span>Please select at least one Purchase Order Status to continue.</span>
    }
  </error-message>
</p-fluid>